// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function setLocaleAndLoadMessages(i18n: any, locale: string) {
  const messages = await import(`./locales/${locale}.json`);
  i18n.setLocaleMessage(locale, messages.default);
  i18n.locale.value = locale;
}
